module.exports = __webpack_public_path__ + "img/antichit-warning.1dadfadf.svg";